/*
 * @Author: your name
 * @Date: 2020-12-15 15:39:17
 * @LastEditTime: 2022-10-28 10:38:23
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/format.js
 */
import store from '@/store'
import dayjs from 'dayjs'

function _getAmPm(hour, min) {
  let mark = ''
  if (parseInt(hour) >= 12) {
    mark = 'PM'
    return `${hour - 12}:${min}${mark}`
  } else {
    mark = 'AM'
    return `${hour}:${min}${mark}`
  }
}

export function _formatCardNum(number) {
  if (!number) return ''
  const a = number.slice(0, 4)
  const b = number.slice(4, 8)
  const c = number.slice(8, 12)
  const d = number.slice(12, 16)
  return `${a} ${b} ${c} ${d}`
}

export function _getFormatDate(date) {
  return date
    .split('-')
    .reverse()
    .join('/')
}

export function _setFormatDate(date) {
  return date
    .split('/')
    .reverse()
    .join('-')
}

export function _getFormatTime(time) {
  const [hour, min] = time.split(':')
  return _getAmPm(hour, min)
}

export function _setFormatTime(time) {
  const [hour, min] = time.split(':')
  const isAM = time.includes('AM')
  if (isAM) {
    return time.replace('AM', '')
  } else {
    const hourFormat24 = parseInt(hour) + 12
    return time
      .replace(hour, hourFormat24)
      .replace('PM', '')
  }
}

export function _formatOpenDate(tabOpenTime) {
  const [date, time] = tabOpenTime.split(' ')
  const formatDate = _getFormatDate(date)
  const formatTime = _getFormatTime(time)
  return formatDate + ' ' + formatTime
}

export function _hexToRgb(h) {
  let r = 0; let g = 0; let b = 0

  // 3 digits
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]

    // 6 digits
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }

  return +r + ',' + +g + ',' + +b
}

/**
 * Reconstruct time format according to country location (year, month, day)
 * @param {time} Date Time
 * @returns A time string whose format is changed according to the format of the country address
 */
/**
 * 根据国家位置重构时间格式（年、月、日）
 * @param {time} 日期时间
 * @returns 一个时间字符串，更改的格式根据国家地址的格式改变
 */
export function _DateFilters(time) {
  const year = dayjs(time).format('YYYY')
  const month = dayjs(time).format('MM')
  const date = dayjs(time).format('DD')
  let country = store.state?.venueHome?.venueCountry ?? 'au'
  const newDate = new Date(Date.UTC(year, month - 1, date))
  if (country === '') country = 'au'

  return new Intl.DateTimeFormat(country, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(newDate)
}
